import i18next from 'i18next'
import { I18nextProvider } from 'react-i18next'
import { createAppFromCommonTemplate, lazyImport } from '@helpers'
import { countryList } from '@velasca/constants'

const { SwitchStore } = lazyImport(
  () => import('@velasca/ui/switch-store'),
  'SwitchStore',
)

export const renderSwitchStoreApp = (switchCountryEl: HTMLElement | null) => {
  createAppFromCommonTemplate(
    switchCountryEl,
    <I18nextProvider i18n={i18next}>
      <SwitchStore countryList={countryList} />
    </I18nextProvider>,
  )
}
